import { render, staticRenderFns } from "./IconDownArrow2.vue?vue&type=template&id=479bf881"
import script from "./IconDownArrow2.vue?vue&type=script&lang=js"
export * from "./IconDownArrow2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports